// @flow
import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { closeOverlay } from '../../store/overlay/actions';
import { getLoggedUser } from '../../store/user/actions';
import { voteQuestion, voteAnswer, optimisticFollow } from '../../store/questions/actions';
import type { StoreType, OverActionType } from '../../types';
import { OverBox } from './OverBox';

const mapStateToProps = (state: StoreType) => ({
  overlay: state.overlay
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      closeOverlay,
      getLoggedUser,
      voteQuestion,
      voteAnswer,
      optimisticFollow
    },
    dispatch
  )
});

type Props = {
  overlay: OverActionType,
  actions: Object
};

const Overlay = ({ overlay, actions }: Props) => {
  const { blob } = overlay;
  if (!blob) return null;

  // TODO: siempre hace like true ?
  const processMessage = (event: Object) => {
    if (event.data.status === 'loggedIn') {
      if (blob.action === 'like') {
        if (blob.target.type === 'question') {
          actions.voteQuestion(blob.target.id, true);
        }
        if (blob.target.type === 'answer') {
          actions.voteAnswer(blob.target.id, true);
        }
      }
      if (blob.action === 'subscribe') {
        actions.optimisticFollow(blob.target.id, true);
      }
      actions.closeOverlay();
      actions.getLoggedUser();
    }
  };

  return <OverBox blob={blob} closeOverlay={actions.closeOverlay} processMessage={processMessage} />;
};

export default connect(mapStateToProps, mapDispatchToProps)(Overlay);
